export class ErroAPI {
    httpStatus: number;
    httpText: number;
    erro: string;
    mensagem: string;
}


// WEBPACK FOOTER //
// ./src/model/geral.ts